// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 获取当前商户信息 POST /api/shop/auth/me */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>("/api/shop/auth/me", {
    method: "POST",
    data: {
      with_keys: 1,
    },
    ...(options || {}),
  });
}

/** 商户退出登录接口 POST /api/shop/auth/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>("/api/shop/auth/logout", {
    method: "POST",
    data: {},
    ...(options || {}),
  });
}

/** 商户登录接口 POST /api/shop/auth/login */
export async function login(
  body: API.LoginParams,
  options?: { [key: string]: any },
) {
  return request<API.LoginResult>("/api/shop/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>("/api/notices", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>("/api/rule", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "update",
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "post",
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>("/api/rule", {
    method: "POST",
    data: {
      method: "delete",
      ...(options || {}),
    },
  });
}

// 获取验证码图片接口
export async function getCaptchaBase64(values: API.FormValues) {
  return request("/api/all/captcha/base64", {
    method: "POST",
    data: values,
  });
}

// 获取省市区树形结构数据接口
export async function getRegionTreeList(values: API.FormValues) {
  return request("/api/all/sysRegion/getTree", {
    method: "POST",
    data: values,
  });
}

/** 商户修改密码接口 POST /api/shop/auth/changePassword */
export async function changePassword(
  body: {
    old_password: string;
    new_password: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ResType>("/api/shop/auth/changePassword", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
